import React from "react";
import { Dispatch } from "redux"
import { Rep } from "../../classes/Workout";
import { State } from "../../reducers";
import { connect } from "react-redux";
import './style/LiveStrengthBar.css';


interface LiveStrengthBarProps {
    activityStatus: string;
    currentRep: Rep;
    pulledWeight: number | string;
    dispatch: Dispatch<any>;
}

const mapStateToProps = (state: State) =>  ({
    activityStatus: state.activities.activityStatus,
    currentRep: state.activities.currentRep	    
});

class LiveStrengthBar extends React.Component<LiveStrengthBarProps> {
    constructor(props: LiveStrengthBarProps) {
        super(props);
    }

    render(){
        const barHeigthPercentage = (typeof this.props.pulledWeight === 'number' ? this.props.pulledWeight / this.props.currentRep.expectedStrength : 0) * 70;
        const barHeight = document.querySelector(".strengthBar") ? document.querySelector(".strengthBar").clientHeight : null;
        const lowerExpectedPercentage = 69;
        const higherExpectedPercentage = 85;
        const inExpectedZone = (barHeigthPercentage > lowerExpectedPercentage && barHeigthPercentage < higherExpectedPercentage);
        const userOut = (this.props.pulledWeight === "Out");
        const displayBarLevel = () => {
            if (userOut || !this.props.currentRep.intensity) {
                return "none";
            }
            return "block";
        }

        return(
            <div className='strengthBarContainer'>
                <div className='zoneBarContainer'>
                    <div className='zoneBar' style={{top: `${barHeight - lowerExpectedPercentage / 100 * barHeight}px`}}></div>
                    <div className='zoneBar' style={{top: `${barHeight - higherExpectedPercentage/ 100 * barHeight}px`}}></div>
                </div>
                
                <div className='strengthBar' style={{opacity: `${inExpectedZone ? "1" : "0.7"}`}}> 
                    <div className='strengthBarLevel' 
                        style={{height: `${barHeigthPercentage < 100 ? barHeigthPercentage : 100}%`,
                            display: `${displayBarLevel()}`,
                            opacity: `${inExpectedZone ? "1" : "0.7"}`}}>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect (mapStateToProps)(LiveStrengthBar);